import { translate } from '../../../../../i18n'
import { BottomButtonGroup } from '../../bottomButtonGroup'
import { BackButton } from '../../buttons/backButton'
import { ButtonOutlinedWarningL } from '../../buttons/buttonOutlinedWarningL'

interface BottomButtonsProps {
    hideNextSpepBtn?: boolean
}
// ページ移動ボタン
const BottomButtons = (props: BottomButtonsProps) => {
    return (
        <BottomButtonGroup>
            {
                !props.hideNextSpepBtn && (
                    <ButtonOutlinedWarningL type="submit" fullWidth>
                        {translate('facilityReservationSelection.button.applyOnTheSelectedSchedule')}
                    </ButtonOutlinedWarningL>                    
                )
            }
            <BackButton />
        </BottomButtonGroup>
    )
}
export default BottomButtons;

